export function OtherChanges({ comment }: { comment: string }) {
  return (
    <div className="flex flex-col gap-3">
      <span className="text-xsm font-medium text-base-primary">
        Other Changes
      </span>
      <div className="flex flex-row gap-2">
        <div className="text-xsm text-base-disabled whitespace-nowrap">
          Comments
        </div>
        <p className="text-xsm text-base-primary m-0">{comment}</p>
      </div>
    </div>
  );
}
